import type { MultipleChoiceEntity } from '@platform/timeline';
import { registerSem } from '../registry';

// TODO(PORT_QUESTIONS): When backend emits typed protobuf payloads for question.multiple_choice.*,
// switch this handler to decode via fromJson(Schema, ev.data) instead of using a loose any cast.

registerSem('question.multiple_choice.started', ({ ev, now, convId }) => {
  const data = (ev.data || {}) as any;
  const entityId = data.question_id || ev.id;
  if (!entityId) return null;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'multiple_choice',
      timestamp: now,
      props: {
        status: 'active',
        question_id: data.question_id,
        question: data.question,
        instructions: data.instructions,
        options: data.options || [],
        allow_multiple: !!data.allow_multiple,
        required: !!data.required,
      },
    } as MultipleChoiceEntity,
  };
});

registerSem('question.multiple_choice.update', ({ ev, now, convId }) => {
  const data = (ev.data || {}) as any;
  const entityId = data.question_id || ev.id;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'multiple_choice',
      timestamp: now,
      props: {
        status: 'active',
        question_id: data.question_id,
        question: data.question,
        instructions: data.instructions,
        options: data.options || [],
        allow_multiple: !!data.allow_multiple,
        required: !!data.required,
      },
    } as MultipleChoiceEntity,
  };
});

registerSem('question.multiple_choice.completed', ({ ev, now, convId }) => {
  const data = (ev.data || {}) as any;
  const entityId = data.question_id || ev.id;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'multiple_choice',
      timestamp: now,
      props: {
        status: data.success === false ? 'error' : 'completed',
        question_id: data.question_id,
        question: data.question,
        instructions: data.instructions,
        options: data.options || [],
        allow_multiple: !!data.allow_multiple,
        required: !!data.required,
        success: data.success,
        error: data.error,
      },
    } as MultipleChoiceEntity,
  };
});
